
import React, { useState } from "react";
import "./Loginstyle.css";
import API from '../Services/Auth'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()


  const userLogin = async () => {
    try {
      if (!email || !password) {
        toast.error("Email and Password are required!");
        return;
      }
      const payload = {
        email,
        password,
      };

      const response = await API.signUp(payload);
      if (response?.status === 200) {
         // console.log("Login successful:", response.data?.token);
        const decodedToken = jwtDecode(response.data?.token);
        localStorage.setItem("token", response.data?.token);
        localStorage.setItem("company_id", decodedToken.company_id);
        localStorage.setItem("loginId", decodedToken.id);
        localStorage.setItem("emp_name", decodedToken.first_name + ' ' + decodedToken.last_name);
        localStorage.setItem("location_id", decodedToken.location_id);
         window.location.replace("/Dashboard")
      } else {
        toast.error(response?.data?.message || "Unexpected error occurred!");
      }
    } catch (err) {
      if (err.response) {
        const { status, data } = err.response;
        if (status === 401) {
          // toast.error(err.response?.data?.message);
          toast.error(err.response?.data?.message);
         
        } else if (status === 500) {
          toast.error("Internal server error. Please try again later.");
        } else {
          // toast.error(data?.message || "An error occurred. Please try again.");
          toast.error(err.response?.data.errors[0].msg)
         // console.log("Error response:",err.response?.data.errors[0].msg);
        }
      } else if (err.request) {
        console.log("Error request:", err.request);
        toast.error("Network error. Please check your connection.");
      } else {
        console.log("Error message:", err.message);
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <div
      style={{
        position: "relative",
        height: "100vh",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url("https://skyjumpertrampolinepark.com/wp-content/uploads/2024/11/biggest-chain-01.webp")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          //opacity: 0.6, // Set your desired opacity here (range 0 to 1)
        }}></div>

      <div
        style={{
          position: "relative", // Ensure the content stays on top of the overlay
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <div className="root1">
          <div className="login">
            <input type="text" placeholder="Username" className="input" value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input type="password" placeholder="Password" className="input" value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button className="button" onClick={userLogin}>Login</button>
            {/* <a
              href="#"
              style={{
                textDecoration: "none",
                color: "rgba(255, 255, 255, 0.6)",
                position: "absolute",
                right: "10px",
                bottom: "10px",
                fontSize: "12px",
              }}
            >
              Forgot Password?
            </a> */}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
